import { Link } from "react-router-dom";
import { Phone, MapPin, Mail } from "lucide-react";

const LOGO_URL = "/images/favicon.png";

const Footer = () => {
  return (
    <footer className="bg-gradient-to-b from-champagne-light to-champagne border-t border-gold-muted/20" data-testid="footer">
      <div className="h-px bg-gradient-to-r from-transparent via-royal-gold/30 to-transparent" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <div className="space-y-6">
            <img src={LOGO_URL} alt="Shree Ganesh Ornaments" className="h-20 w-auto" />
            <p className="text-charcoal/60 font-body text-sm leading-relaxed max-w-xs">
              Crafting timeless silver masterpieces for generations. Your trusted destination for premium retail and wholesale silver ornaments.
            </p>
          </div>

          <div>
            <h3 className="font-display text-sm tracking-[0.3em] uppercase text-royal-gold mb-6">Navigation</h3>
            <nav className="space-y-3">
              {[{ path: "/", label: "Home" }, { path: "/products", label: "Collections" }, { path: "/about", label: "Our Heritage" }, { path: "/contact", label: "Enquire Now" }].map((link) => (
                <Link key={link.path} to={link.path} className="block text-charcoal/60 hover:text-royal-gold transition-colors font-body text-sm">{link.label}</Link>
              ))}
            </nav>
          </div>

          <div>
            <h3 className="font-display text-sm tracking-[0.3em] uppercase text-royal-gold mb-6">Visit Us</h3>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <MapPin size={18} className="text-royal-gold flex-shrink-0 mt-1" />
                <p className="text-charcoal/60 font-body text-sm leading-relaxed">1396, Devadinni Pole, Rangati Bajar Road, M.G Haveli Road, Manekchowk, Ahmedabad – 380001</p>
              </div>
              <a href="tel:+919104054259" className="flex items-center space-x-3 text-charcoal/60 hover:text-royal-gold transition-colors">
                <Phone size={18} className="text-royal-gold" /><span className="font-body text-sm">+91 9104054259</span>
              </a>
              <a href="tel:+919737777555" className="flex items-center space-x-3 text-charcoal/60 hover:text-royal-gold transition-colors">
                <Phone size={18} className="text-royal-gold" /><span className="font-body text-sm">+91 9737777555</span>
              </a>
              <a href="mailto:info@shreeganeshornaments.com" className="flex items-center space-x-3 text-charcoal/60 hover:text-royal-gold transition-colors">
                <Mail size={18} className="text-royal-gold" /><span className="font-body text-sm">info@shreeganeshornaments.com</span>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-royal-gold/10 text-center">
          <p className="text-charcoal/40 font-body text-xs tracking-widest uppercase">© {new Date().getFullYear()} Shree Ganesh Ornaments — Purveyors of Fine Silver</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
